export default [
  {
    path: '/ticketdepartment',
    name: 'ticketdepartment',
    component: () => import('@/views/menu/ticket/ticketdepartment.vue'),
    meta: {
      pageTitle: 'مدیریت دپارتمان تیکت',
      action: 'show',
      resource: 'TicketDepartmentManager',
    },
  },
  {
    path: '/ticketdepartment/details',
    name: 'addticketdepartment',
    component: () => import('@/views/menu/ticket/ticketdepartmentdetails.vue'),
    meta: {
      pageTitle: 'ایجاد دپارتمان تیکت',
      action: 'show',
      resource: 'TicketDepartmentManager',
    },
  },
  {
    path: '/ticketdepartment/details/:id',
    name: 'updateticketdepartment',
    component: () => import('@/views/menu/ticket/ticketdepartmentdetails.vue'),
    meta: {
      pageTitle: 'ویرایش دپارتمان تیکت',
      action: 'show',
      resource: 'TicketDepartmentManager',
    },
  },
  {
    path: '/ticket/List',
    name: 'ticketList',
    component: () => import('@/views/menu/ticket/ticketList.vue'),
    meta: {
      pageTitle: 'لیست تیکت ها',
      action: 'show',
      resource: 'TicketManager',
    },
  },
  {
    path: '/ticket/reply/:id',
    name: 'ticketReply',
    component: () => import('@/views/menu/ticket/ticketReply.vue'),
    meta: {
      pageTitle: 'پاسخ به تیکت',
      action: 'show',
      resource: 'TicketManager',
    },
  },

]
